const domModule = weex.requireModule('dom')
export function getBoundingClientRectBase(dom, element, func) {
  dom && dom.getComponentRect(element, func)
}

export function getBoundingClientRect(dom, element, func, delay = 50) {
  setTimeout(() => dom && dom.getComponentRect(element, func), delay)
}

export function getBoundingClientRectAsync(dom, element) {
  return new Promise(resolve => {
    setTimeout(() => dom && dom.getComponentRect(element, res => res.result && resolve(res.size)), 0)
  })
}



// WEBPACK FOOTER //
// ./packages/utils/dom.js